<template>
  <div class="user-management-container">
    <vab-query-form>
      <vab-query-form-right-panel :span="24">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <el-form-item>
            <el-input
              v-model.trim="queryForm.keyword"
              clearable
              placeholder="请输入昵称/姓名/手机号"
            />
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="queryData">
              查询
            </el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>

    <el-table v-loading="listLoading" stripe :data="list">
      <el-table-column align="left" label="序号" width="55">
        <template #default="{ $index }">
          {{ $index + 1 }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="头像"
        prop="basic.avatar"
        show-overflow-tooltip
        width="80px"
      >
        <template #default="{ row }">
          <img class="avatar" :src="row.basic.avatar" />
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="昵称"
        prop="basic.name"
        show-overflow-tooltip
        width="160px"
      />
      <el-table-column
        align="left"
        label="性别"
        prop="basic.sex"
        show-overflow-tooltip
        width="160px"
      >
        <template #default="{ row }">
          {{ row.basic.sex == 1 ? '先生' : '女士' }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="省份"
        prop="basic.province"
        show-overflow-tooltip
        width="160px"
      />
      <el-table-column
        align="left"
        label="城市"
        prop="basic.city"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="注册日期"
        prop="created"
        show-overflow-tooltip
        width="160px"
      >
        <template #default="{ row }">
          {{ moment(row.created).format('YYYY-MM-DD') }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        fixed="right"
        label="操作"
        show-overflow-tooltip
        width="120px"
      >
        <template #default="{ row }">
          <el-button type="text" class="mr-10" @click="handleShow(row)">
            详情
          </el-button>
        </template>
      </el-table-column>
      <template #empty>
        <el-image
          class="vab-data-empty"
          :src="require('@/assets/empty_images/data_empty.png')"
        />
      </template>
    </el-table>
    <el-pagination
      background
      :current-page="queryForm.page"
      :layout="layout"
      :page-size="queryForm.size"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
    <edit ref="edit" @fetch-data="fetchData" />
    <detail ref="show" />
  </div>
</template>

<script>
  import moment from 'moment'
  import { getPeoples } from '@/api/people'
  import Edit from './edit'
  import Detail from './detail.vue'
  export default {
    name: 'PeoplePeople',
    components: { Edit,Detail },
    data() {
      return {
        moment,
        levels: {},
        list: [],
        listLoading: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
        selectRows: '',
        queryForm: {
          page: 1,
          size: 10,
          keyword: '',
        },
      }
    },
    created() {
      this.fetchData()
    },
    methods: {
      handleShow(row) {
      this.$refs['show'].show(row)
    },
      handleEdit(row) {
        if (row.peopleId) {
          this.$refs['edit'].showEdit(row)
        } else {
          this.$refs['edit'].showEdit()
        }
      },
      handleSizeChange(val) {
        this.queryForm.size = val
        this.fetchData()
      },
      handleCurrentChange(val) {
        this.queryForm.page = val
        this.fetchData()
      },
      queryData() {
        this.queryForm.page = 1
        this.fetchData()
      },
      async fetchData() {
        this.listLoading = true
        const { list, total } = await getPeoples(this.queryForm)
        this.list = list
        this.total = total
        this.listLoading = false
      },
    },
  }
</script>

<style lang="scss" scoped>
  .avatar {
    width: 40px;
    height: 40px;
  }
</style>
